<template>
  <div class="sidebar">
    <profile-info></profile-info>
  </div>
</template>

<script>
import ProfileInfo from "@/components/sidebar/ProfileInfo";

export default {
  name: "AppSidebar",
  components: { ProfileInfo },
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 100%;
}
</style>
